import { basename } from "@tsmono/util";

import { parseLogFileName } from "../../../../utils/evallog";

import { LogListRow } from "./types";

/**
 * Sort/filter value for the Completed column. Never-completed logs (status
 * `started`, including currently-running evals) have no completion date —
 * `completedAt` arrives as `""` or undefined; fall back to the timestamp
 * embedded in the log file name so a Completed-descending sort slots them
 * by recency — a just-started eval surfaces at the top — instead of
 * coercing the missing date to epoch 0 and sinking them to the bottom.
 */
export const completedAtValue = (row: LogListRow): string | undefined =>
  row.completedAt ||
  parseLogFileName(basename(row.name)).timestamp?.toISOString();
